import { memo } from "react";
import { Grid, Checkbox } from "semantic-ui-react";
import { HandleCheckboxChange } from "../../../../../../custom-hooks/form/types";

type GatewayStatusProps = {
  onChange: HandleCheckboxChange;
  enableGateway?: boolean;
};

const GatewayStatus = ({ onChange, enableGateway }: GatewayStatusProps) => {
  return (
    <>
      <Grid.Column
        textAlign="left"
        width={8}
        className="flex vbottom margin-top-20"
      >
        <h5>Gateway</h5>
      </Grid.Column>
      <Grid.Column textAlign="left" width={8} className="margin-top-20">
        <Checkbox
          className="display-inlineblock"
          toggle
          checked={enableGateway}
          label={enableGateway ? "Enabled" : "Disabled"}
          name="enableGateway"
          onChange={onChange}
        />
      </Grid.Column>
    </>
  );
};

export default memo(GatewayStatus);
